module.exports = __webpack_public_path__ + "static/media/treeFace.ed2d7491.png";